export const emailExclusionList = [
  'gmail',
  'yahoo',
  'outlook',
  'hotmail',
  'aol',
  'icloud',
  '.mail',
  'zoho',
  'protonmail',
  'yandex'
];
